import getDuration from './getDuration'
import getNightHours from './getNightHours'

export default function getDayHours(start, end, nightStart) {
  const nightHours = getNightHours(start, end, nightStart)
  return getDuration(start, end) - nightHours
}
